export default function apiCall(url, reqOptions, component) {
  return new Promise((resolve, reject) => {
    try {
      fetch(url, reqOptions).then(
        (res) => {
          if (component._isMounted) {
            if (res.status === 401) {
              // alert('Unauthorized. Either your session has expired or you are not authorized to perform this action. Please try logging out and logging in again.')
              if (
                confirm(
                  "Unauthorized. Either your session has expired or you are not authorized to perform this action. Redirect to login page?"
                )
              ) {
                component.props.history.push("/log_in");
              }
            } else if (res.status === 500) {
              reject(res.statusText);
            } else {
              res.json().then((data) => {
                resolve(data);
              });
            }
          } /**component stil _isMounted block**/
        } /** arrow function **/
      ); /** .then() **/
    } catch (err) {
      if (component._isMounted) {
        reject(err);
      }
    }
  });
}
